export const REVIEWED_AT = "2026-09-08";

/** Categories re-reviewed against their official sources after REVIEWED_AT. */
const CATEGORY_REVIEWED_AT: Record<string, string> = { ai: "2026-10-29", cloud: "2026-10-29", databases: "2026-10-29" };
export const reviewedAtFor = (category: string) => CATEGORY_REVIEWED_AT[category] ?? REVIEWED_AT;
